export const GET_FILTERED_AND_PAGINATED_ATTENDANTS_REQUESTED =
  'GET_FILTERED_AND_PAGINATED_ATTENDANTS_REQUESTED'
export const GET_FILTERED_AND_PAGINATED_ATTENDANTS_SUCCEEDED =
  'GET_FILTERED_AND_PAGINATED_ATTENDANTS_SUCCEEDED'
export const GET_FILTERED_AND_PAGINATED_ATTENDANTS_FAILED =
  'GET_FILTERED_AND_PAGINATED_ATTENDANTS_FAILED'

export const CREATE_ATTENDANT_WITH_ROLE_REQUESTED =
  'CREATE_ATTENDANT_WITH_ROLE_REQUESTED'
export const CREATE_ATTENDANT_WITH_ROLE_SUCCEEDED =
  'CREATE_ATTENDANT_WITH_ROLE_SUCCEEDED'
export const CREATE_ATTENDANT_WITH_ROLE_FAILED =
  'CREATE_ATTENDANT_WITH_ROLE_FAILED'

export const UPDATE_ATTENDANT_WITH_ROLE_REQUESTED =
  'UPDATE_ATTENDANT_WITH_ROLE_REQUESTED'
export const UPDATE_ATTENDANT_WITH_ROLE_SUCCEEDED =
  'UPDATE_ATTENDANT_WITH_ROLE_SUCCEEDED'
export const UPDATE_ATTENDANT_WITH_ROLE_FAILED =
  'UPDATE_ATTENDANT_WITH_ROLE_FAILED'

export const UPDATE_ATTENDANT_REQUESTED = 'UPDATE_ATTENDANT_REQUESTED'
export const UPDATE_ATTENDANT_SUCCEEDED = 'UPDATE_ATTENDANT_SUCCEEDED'
export const UPDATE_ATTENDANT_FAILED = 'UPDATE_ATTENDANT_FAILED'
